// Migration shim — Supabase has been removed in favour of Cloudflare Pages
// Functions. The form components still call
//   supabase.functions.invoke("<edge-function>", { body })
// so this shim preserves that exact surface and shape ({ data, error }),
// mapping the old edge-function names to the new /api/* routes.

const ROUTE_MAP: Record<string, string> = {
  "submit-contact": "/api/contact",
  "subscribe-newsletter": "/api/newsletter",
  "submit-forge-request": "/api/forge-request",
};

interface InvokeResult<T = unknown> {
  data: T | null;
  error: { message: string } | null;
}

async function invoke<T = unknown>(
  name: string,
  options?: { body?: unknown },
): Promise<InvokeResult<T>> {
  const route = ROUTE_MAP[name];
  if (!route) {
    return { data: null, error: { message: `Unknown function: ${name}` } };
  }

  try {
    const res = await fetch(route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(options?.body ?? {}),
    });

    let data: T | null = null;
    try {
      data = (await res.json()) as T;
    } catch {
      data = null;
    }

    if (!res.ok) {
      const message =
        (data as { error?: string } | null)?.error || `Request failed (${res.status})`;
      return { data, error: { message } };
    }

    return { data, error: null };
  } catch (err) {
    return {
      data: null,
      error: { message: err instanceof Error ? err.message : "Network error" },
    };
  }
}

export const supabase = {
  functions: { invoke },
};
